import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const PersonalizedTemplatesV2Loadable: LoadableType<{
	isXflow: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PersonalizedTemplatesV2" */ './PersonalizedTemplatesV2.tsx'
			)
		).PersonalizedTemplatesV2ErrorBoundary,
});
